import { UserMergeRequestStatus } from 'src/graphql/generated/graphql';
import { Chip } from '@otp/ui';
import React from 'react';
import { useTranslation } from 'react-i18next';

const statusColorMap = {
  [UserMergeRequestStatus.Rejected]: 'error',
  [UserMergeRequestStatus.Pending]: 'primary',
  [UserMergeRequestStatus.Approved]: 'success',
};

type StatusProps = {
  status?: UserMergeRequestStatus;
};

export const StatusColumn = ({ status }: StatusProps) => {
  const { t } = useTranslation();

  if (!status) {
    return null;
  }

  return (
    <Chip
      label={t(`user-merge-requests.list.columns.status-${status.toLowerCase()}`)}
      size="small"
      color={statusColorMap[status] as any}
      className="!ml-0"
    />
  );
};
